import {activeTheme} from "@frontend/themes/activeTheme"

/**
 * Inject the active brand's webfont(s) into the parent document (not
 * shadow DOM). Delegates to `activeTheme.fonts.load()`, which each brand
 * definition implements (self-hosted stylesheet vs. external link);
 * loaders are idempotent, so this is safe to call from every entry point.
 */
export const ensureBrandFonts = (): void => {
  activeTheme.fonts.load()
}
